<template>
	<div id="particle-background-left" class="particle-background-left" />
</template>

<script>
	import particlesConfig from './config.js';

	export default {
		mounted () {
			const _particle = window.particlesJS;
			_particle('particle-background-left', particlesConfig);
		}
	}
</script>

<style lang="scss" scoped>
	.particle-background-left,
	.particle-background-right,
	.particle-background-circles {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		pointer-events: none;
		z-index: 0;
	}

	.particle-background-left {
		filter: blur(4px);
	}
</style>
